import DateUtil from '@utils/DateUtil';
import nl2br from 'nl2br';
import ProjectApi from '@api/ProjectApi';
import Vue from 'vue';
import AgencyApi from './js/api/AgencyApi';
import UserApi from './js/api/UserApi';

Vue.mixin({

    computed: {

        modal() {
            return this.$store.getters.modal;
        },

        user() {
            return this.$store.getters.user;
        },

        project() {
            return this.$store.getters.project;
        },

    },

    methods: {

        _track(name, data = null) {
            if (window.fbq) {
                window.fbq('track', name, data);
            }
        },

        _openLink(url, target = '_blank') {
            if (url && target === '_blank') {
                window.open(url, '_blank', 'noopener');
            } else if (url) {
                window.location.href = url;
            }
        },

        _localize(slug, lang = 'en') {
            return this.$t(slug, lang);
        },

        _nl2br(val) {
            return nl2br(val);
        },

        _hasSection(slug) {
            let member = this.$store.getters.member;
            return member ? member.sections.find(s => s.slug === slug) : false;
        },

        _getDate(val) {
            return DateUtil.dateTime(val);
        },

        _setModal(slug) {
            this.$store.commit('setModal', slug);
        },

        _refreshUser() {
            this.$store.commit('loading', true);
            UserApi.getUser()
                .then((response) => {
                    this.$store.commit('loading', false);
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

        _refreshProject() {
            this.$store.commit('loading', true);
            ProjectApi.getProject(this.project.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

        _refreshAgency() {
            let agency = this.user.agency;
            if (!agency) return;
            this.$store.commit('loading', true);
            AgencyApi.getAgency(agency.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

});